export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LdoHrEtAAAAACuI_s0Jh6HLaHhOiHAWWEnm7rDN',
  },

   //baseUrl: 'https://localhost:7249/api/'
  baseUrl: 'https://www.nonbankatmsurchargesettlement.com/api/'
    // baseUrl: 'https://nonbankatmsurchargesett-dev-f0apf8ewfeg9e2g4.centralus-01.azurewebsites.net/api/'

};

